import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtmsFromUrl, isInternalLeadNavigation } from '../../lib/utm';

/**
 * UtmCapture: drop-in component (renders nothing).
 * On every navigation that brings UTMs in the query string, atomically
 * replaces the persisted UTM cookies. Reads on mount + on each location change.
 */
const UtmCapture = () => {
  const location = useLocation();
  const capturedLanding = useRef(isInternalLeadNavigation());

  useEffect(() => {
    captureUtmsFromUrl(location.search, {preserveStored:capturedLanding.current});
    capturedLanding.current = true;
  }, [location.search]);

  return null;
};

export default UtmCapture;
